// Layouts
import React from 'react';
import { FindifyMenuProvider } from '@/contexts/FindifyMenuContext';
import { FindifyDataProvider } from '@/contexts/FindifyDataContext';
import AppWithoutProviders from './AppWithoutProviders';

// Set providers here so they can be used in AppWithoutProviders if needed
function App(): JSX.Element {
  return <FindifyDataProvider>
    <FindifyMenuProvider>
      <AppWithoutProviders />
    </FindifyMenuProvider >
  </FindifyDataProvider>
}

export default App;
